import { z } from 'zod';
import { AbstractPostQuoteRequestSchema } from '../quote/post-quote.ts';
import { CustomisedQuotePayloadByProductTypeSchema } from '../quote/quote-payload.ts';

const InternalCustomRequestPostPayload = AbstractPostQuoteRequestSchema.merge(
    z.object({
        id: z.string(),
        createdAt: z.coerce.date(),
    })
)
    .omit({ callbackUrl: true })
    .and(CustomisedQuotePayloadByProductTypeSchema);

/**
 * validation schema for whole (merged) request payload
 */
export const InternalPostQuoteRequestSchema = InternalCustomRequestPostPayload;
export type InternalPostQuoteRequest = z.infer<typeof InternalPostQuoteRequestSchema>;
